<div class="container">
  <h2 class="my-5">Places To Go</h2>

  <section class="row" id="taniti_city">
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
    <div class="col-md-9">
      <h3>Taniti City</h3>
      <p>
        Despite its role as the administrative center, Taniti City is closely connected to the natural environment
        that defines the island. Just minutes from the city center are several pristine beaches, including Yellow Leaf Bay,
        a popular destination for both leisure and local events.
      </p>
      <p>
        The city's coastal location provides opportunities for swimming, snorkeling, and guided eco-tours of nearby
        marine sanctuaries. Walking and cycling paths along the shoreline offer a peaceful retreat and scenic views
        of Taniti's natural landscapes.
      </p>
    </div>
  </section>

  <hr class="my-5">

  <section class="row" id="mont_fatu">
    <div class="col-md-9">
      <h3>Tanitian Volcano</h3>
      <p>
        Taniti's natural landscape is as diverse as it is breathtaking. From the verdant hills to the sparkling shores,
        the island is a haven for eco-tourism. At the heart of Taniti lies Mont Fatu, an active volcano that has shaped
        the island's ecosystem for centuries.
      </p>
      <p>
        Mont Fatu: As one of the most active volcanoes in the Pacific, Mont Fatu offers a remarkable spectacle for visitors.
        Safe viewing areas and guided tours provide opportunities to witness the volcanic activity from a distance, while expert
        guides share insights into the volcano's geological significance and the island's ongoing efforts to monitor and manage
        volcanic risks.
      </p>
    </div>
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
  </section>

  <hr class="my-5">

  <section class="row" id="rainforest">
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
    <div class="col-md-9">
      <h3>The Umazon Rainforest</h3>
      <p>
        Nestled in the heart of Taniti, the island's lush tropical rainforest stands as one of its most treasured natural assets.
        Spanning thousands of acres, this verdant landscape is a sanctuary of biodiversity, home to a remarkable array of endemic
        plant and animal species found nowhere else in the world.
      </p>
      <p>
        Visitors to Taniti's rainforest will find themselves immersed in a vibrant ecosystem where towering canopy trees, cascading
        waterfalls, and winding jungle trails invite exploration and reflection. The forest thrives with the sounds of native birds,
        the rustle of unseen wildlife, and the gentle rhythm of flowing streams.
      </p>
    </div>
  </section>


  <hr class="my-5">

  <section class="row" id="yellow_leaf">
    <div class="col-md-9">
      <h3>Yellow Leaf Bay</h3>
      <p>
        Yellow Leaf Bay, located on the western coast of Taniti, is a pristine haven renowned for its sweeping white sand beaches,
        crystal-clear waters, and tranquil tropical charm. This picturesque destination offers the perfect blend of relaxation and
        recreation, making it a must-visit for travelers of all kinds.
      </p>
      <p>
        In addition to its natural beauty, Yellow Leaf Bay is home to one of Taniti’s premier golf courses. Surrounded by lush
        greenery and ocean views, the course offers a challenging yet enjoyable experience for golfers of all skill levels.
        Clubhouse amenities and professional instruction are also available.
      </p>
    </div>
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
  </section>

</div>
